import respinosDevice from "../../../../assets/img/background/background2.png";
import background from "../../../../assets/img/background/background4.jpg";
import googlePlay from "../../../../assets/img/logo/google-play-w.png";
import itb from "../../../../assets/img/logo/itb.png";
import mobileApp from "../../../../assets/img/logo/mobile-app.png";
import unair from "../../../../assets/img/logo/unair.png";
import unpad from "../../../../assets/img/logo/unpad.png";
import { RESPINOS_LINK } from "../../../../config/constant";

const HeroLogin = (props) => {
  return (
    <section className="hidden lg:flex w-full px-10 py-8 relative lg:flex-col justify-between">
      <div
        className="relative overflow-hidden bg-cover bg-center px-20 py-16 xl:py-36 rounded-xl shadow-lg flex flex-col space-y-16"
        style={{
          height: "calc(100% - 15rem)",
          backgroundImage: `url("${background}")`,
        }}
      >
        <div className="absolute inset-0 bg-white bg-opacity-50 " />
        <div className="absolute bottom-10 xl:bottom-auto z-10 left-10 xl:left-auto right-auto xl:right-20 top-auto xl:top-12">
          <div className="flex space-x-10 items-center">
            <div className="w-24 xl:w-28 flex-shrink-0 relative">
              <img
                src={respinosDevice}
                alt=""
                className="transform rotate-12"
              />
            </div>
            <div>
              <div className="text-4xl xl:text-5xl font-black text-primary">
                Respinos Web Application
              </div>
              <div className="mt-3 text-white bg-primary text-lg  rounded-lg bg-opacity-60 inline-block px-2 py-1">
                Diagnosa respirasi dengan lebih mudah.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-white px-10 py-10 rounded-xl mt-6 xl:mt-12 shadow-lg"
        style={{ minHeight: "20vh" }}
      >
        <div className="flex items-center justify-center xl:justify-between">
          <div className="flex space-x-6 items-center">
            <div className="flex-shrink-0">
              <img src={mobileApp} alt="respinos-web-app" />
            </div>
            <div className="text-sm max-w-xs">
              <h3 className="font-semibold uppercase">Respinos</h3>
              <p>
                Respiration diagnosis with smart app monitoring. Also available
                on smartphone.
              </p>
              <div className="mt-2 flex space-x-2">
                <a
                  href={RESPINOS_LINK.android}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={googlePlay} alt="google-play" className="h-6" />
                </a>
                {/* <img src={appStore} alt="app-store" className="h-10" /> */}
              </div>
            </div>
          </div>

          <div className="hidden xl:block">
            <h3 className="mt-5 xl:mt-3">In asossiation with :</h3>
            <div className="mt-2 flex space-x-3">
              <img src={itb} alt="itb" className="w-16" />
              <img src={unpad} alt="unpad" className="w-16" />
              <img src={unair} alt="unair" className="w-16" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroLogin;
